import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconGameCollection: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.25 1.5H3.75C3.33579 1.5 3 1.83579 3 2.25V15.75C3 16.1642 3.33579 16.5 3.75 16.5H14.25C14.6642 16.5 15 16.1642 15 15.75V2.25C15 1.83579 14.6642 1.5 14.25 1.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M7.875 5.25H12.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.875 9H12.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.875 12.75H12.375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask id="path-5-inside-1_13361_5676" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 6C6.03922 6 6.375 5.66422 6.375 5.25C6.375 4.83578 6.03922 4.5 5.625 4.5C5.21078 4.5 4.875 4.83578 4.875 5.25C4.875 5.66422 5.21078 6 5.625 6Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 6C6.03922 6 6.375 5.66422 6.375 5.25C6.375 4.83578 6.03922 4.5 5.625 4.5C5.21078 4.5 4.875 4.83578 4.875 5.25C4.875 5.66422 5.21078 6 5.625 6Z"
      fill="currentColor"
    />
    <path
      d="M5.625 6V7.5C6.86765 7.5 7.875 6.49265 7.875 5.25H6.375H4.875C4.875 4.8358 5.2108 4.5 5.625 4.5V6ZM6.375 5.25H7.875C7.875 4.00735 6.86765 3 5.625 3V4.5V6C5.2108 6 4.875 5.6642 4.875 5.25H6.375ZM5.625 4.5V3C4.38235 3 3.375 4.00735 3.375 5.25H4.875H6.375C6.375 5.6642 6.0392 6 5.625 6V4.5ZM4.875 5.25H3.375C3.375 6.49265 4.38235 7.5 5.625 7.5V6V4.5C6.0392 4.5 6.375 4.8358 6.375 5.25H4.875Z"
      fill="currentColor"
      mask="url(#path-5-inside-1_13361_5676)"
    />
    <mask id="path-7-inside-2_13361_5676" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 9.75C6.03922 9.75 6.375 9.41422 6.375 9C6.375 8.58578 6.03922 8.25 5.625 8.25C5.21078 8.25 4.875 8.58578 4.875 9C4.875 9.41422 5.21078 9.75 5.625 9.75Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 9.75C6.03922 9.75 6.375 9.41422 6.375 9C6.375 8.58578 6.03922 8.25 5.625 8.25C5.21078 8.25 4.875 8.58578 4.875 9C4.875 9.41422 5.21078 9.75 5.625 9.75Z"
      fill="currentColor"
    />
    <path
      d="M5.625 9.75V11.25C6.86765 11.25 7.875 10.2427 7.875 9H6.375H4.875C4.875 8.5858 5.2108 8.25 5.625 8.25V9.75ZM6.375 9H7.875C7.875 7.75735 6.86765 6.75 5.625 6.75V8.25V9.75C5.2108 9.75 4.875 9.4142 4.875 9H6.375ZM5.625 8.25V6.75C4.38235 6.75 3.375 7.75735 3.375 9H4.875H6.375C6.375 9.4142 6.0392 9.75 5.625 9.75V8.25ZM4.875 9H3.375C3.375 10.2427 4.38235 11.25 5.625 11.25V9.75V8.25C6.0392 8.25 6.375 8.5858 6.375 9H4.875Z"
      fill="currentColor"
      mask="url(#path-7-inside-2_13361_5676)"
    />
    <mask id="path-9-inside-3_13361_5676" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 13.5C6.03922 13.5 6.375 13.1642 6.375 12.75C6.375 12.3358 6.03922 12 5.625 12C5.21078 12 4.875 12.3358 4.875 12.75C4.875 13.1642 5.21078 13.5 5.625 13.5Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 13.5C6.03922 13.5 6.375 13.1642 6.375 12.75C6.375 12.3358 6.03922 12 5.625 12C5.21078 12 4.875 12.3358 4.875 12.75C4.875 13.1642 5.21078 13.5 5.625 13.5Z"
      fill="currentColor"
    />
    <path
      d="M5.625 13.5V15C6.86765 15 7.875 13.9927 7.875 12.75H6.375H4.875C4.875 12.3358 5.2108 12 5.625 12V13.5ZM6.375 12.75H7.875C7.875 11.5073 6.86765 10.5 5.625 10.5V12V13.5C5.2108 13.5 4.875 13.1642 4.875 12.75H6.375ZM5.625 12V10.5C4.38235 10.5 3.375 11.5073 3.375 12.75H4.875H6.375C6.375 13.1642 6.0392 13.5 5.625 13.5V12ZM4.875 12.75H3.375C3.375 13.9927 4.38235 15 5.625 15V13.5V12C6.0392 12 6.375 12.3358 6.375 12.75H4.875Z"
      fill="currentColor"
      mask="url(#path-9-inside-3_13361_5676)"
    />
  </svg>
);
